import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { FlatButton, FontIcon, RaisedButton } from 'material-ui';
import { either, equals, isNil, isEmpty, flatten, merge } from 'ramda';

const isNilOrEmpty = either(isNil, isEmpty);

const Tags = props => {
  const {
    MMReducer,
    updateMMProp,
  } = props;

  const combineLocationAndProduct = MMReducer.locationTags.concat(MMReducer.productTags);
  const convertToSelectField = combineLocationAndProduct.map(obj => ({ value: obj.id, label: obj.name }));
  const selectedTagNames = flatten(MMReducer.tags.map(id => combineLocationAndProduct.filter(obj => obj.id === id).map(obj => obj.name)));

  const editState = () => {
    const addIndex = MMReducer.media.map((obj, index) => merge(obj, { index }));
    const selectedFilesForTags = addIndex.filter(obj => {
      if (MMReducer.tags.every(i => (obj.tags || []).indexOf(i) !== -1)) return obj;
    });
    return (
      <div style={{ border: equals(MMReducer.tagsStep, 1) ? '1px solid #d3d3d3' : '', padding: '10px' }}>
        <b>Step One:</b> Select which location(s) / product(s) you would like to manage.
        <div style={{ marginTop: '10px' }}>
          <Select
            name="mmTags"
            onChange={(value) => updateMMProp({ tags: value.map(obj => obj.value) })}
            options={convertToSelectField}
            value={MMReducer.tags}
            multi
            clearable={false}
          />
        </div>
        <div style={{ display: 'block', textAlign: 'right', marginTop: '10px' }}>
          <RaisedButton
            key="MMNextButton"
            label="Next"
            labelStyle={{ fontWeight: '600', top: '4px' }}
            onTouchTap={() => updateMMProp({
              tagsStep: 2,
              selectedFiles: selectedFilesForTags,
            })}
            secondary
            disabled={isNilOrEmpty(MMReducer.tags)}
            style={{ width: '80px', borderRadius: '3px', height: '32px' }}
          />
        </div>
      </div>
    );
  };

  const displayState = () => {
    return (
      <div>
        Managing tags for: <b>{[selectedTagNames.slice(0, -1).join(', '), selectedTagNames.slice(-1)[0]].join(selectedTagNames.length < 2 ? '' : ', and ')}</b>.
        <FlatButton
          secondary
          hoverColor="none"
          style={{ fontSize: '12px' }}
          label="Edit"
          labelStyle={{ paddingLeft: '3px' }}
          labelPosition="after"
          onTouchTap={() => updateMMProp({ tagsStep: 1 })}
        >
          <FontIcon
            className="tc-icon-mode_edit"
            style={{ color: '#00bcd4', cursor: 'pointer', fontSize: '14px' }}
          />
        </FlatButton>
      </div>
    );
  };

  return (
    <div>
      <h5 style={{ color: 'rgba(0, 0, 0, 0.54)' }}>You can assign tags to files so that they also appear on your location or product profiles.</h5>
      {equals(MMReducer.tagsStep, 1) ? editState() : displayState()}
    </div>
  );
};

Tags.propTypes = {
  MMReducer: PropTypes.object,
  updateMMProp: PropTypes.func,
};

const mapStateToProps = ({ marketingMaterials }) => ({
  MMReducer: marketingMaterials.mainReducer.toJS(),
});

export default connect(mapStateToProps)(Tags);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/tags.jsx